<template>
  <div :class="[{ show: showDialog }]" class="theme__popup" v-click-outside="forceClose">
    <button
      type="button"
      style="margin-left: 0.25rem; display: flex; flex-direction: column"
      class="open-btn"
      @click="onClickOpen"
    >
      <div class="theme__list-row-coverage-percent">{{ roundToTwo(theme.sentiment.compound) }}</div>
      <div class="theme__list-row-coverage-num-responses">
        {{ theme.sentiment.label }}
      </div>
    </button>
    <DialogPopup
      class="theme__popup-dialog"
      header-tag="h4"
      :show="showDialog"
      @close="showDialog = false"
      v-if="Object.keys(numeratorDetails).length > 0"
      style="width: 20rem"
    >
      <template #header>
        <div
          style="
            display: flex;
            flex-direction: row;
            text-align: left;
            font-size: 1rem;
            text-transform: none;
          "
        >
          Sentiment for the theme:
        </div>
        <span
          class="theme__popup-dialog-name"
          style="
            font-family: Core-Sans;
            text-align: left;
            font-size: 1rem;
            text-transform: none;
            margin-left: 0.5rem;
            text-decoration: none;
          "
          >&nbsp;{{ theme.name }}</span
        >
      </template>
      <template #body>
        <div v-if="theme">
          <div
            style="
              text-align: left;
              display: flex;
              flex-direction: column;
              text-transform: none;
              padding-left: 0.5rem;
            "
          >
            <div style="display: flex">
              This score averages the 'sentiment' of each of the comments that include this theme.
            </div>
            <ul style="margin-left: -1.25rem">
              <li>Scores range from -1 (very negative) to 1 (very positive)</li>
              <li>
                <VisibleText
                  >We use Bert and
                  <a
                    target="_blank"
                    href="https://huggingface.co/cardiffnlp/twitter-roberta-base-sentiment-latest"
                    >cardiffnlp/twitter-roberta-base-sentiment-latest<SvgIconDecorative
                      icon="externalLink"
                  /></a>
                </VisibleText>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </DialogPopup>
  </div>
</template>

<script>
import DialogPopup from '@/components/UI/DialogPopup.vue';
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';

export default {
  name: 'SentimentPopup',
  components: {
    DialogPopup,
    SvgIconDecorative,
  },
  props: {
    theme: {
      default: () => {},
      type: Object,
    },
    sortedResponsesLength: {
      type: Number,
      required: false,
      default: () => 0,
    },
  },
  data() {
    return {
      showDialog: false,
      numeratorDetails: {},
    };
  },
  created() {
    this.updateDetails();
  },
  computed: {
    parsedCoverage() {
      if (this.theme.coverage.total > -1) {
        return this.theme.coverage.total;
      }
      return 0;
    },
    parsedFilteredCoverage() {
      if (this.theme.filtered_coverage.total >= 0) {
        return this.theme.filtered_coverage.total;
      }
      return -1;
    },
    hasFilter() {
      if (this.theme.filtered_coverage && this.theme.filtered_coverage?.matching_responses.length) {
        return true;
      }
      return false;
    },
    percentage() {
      let percentage = 0;
      if (this.hasFilter) {
        percentage = (this.parsedFilteredCoverage / this.sortedResponsesLength) * 100;
        return percentage.toFixed(1);
      }
      percentage = (this.parsedCoverage / this.sortedResponsesLength) * 100;
      return percentage.toFixed(1);
    },
  },
  methods: {
    roundToTwo(num) {
      return +(Math.round(num + 'e+2') + 'e-2');
    },
    updateDetails() {
      if (this.hasFilter && this.theme.filtered_coverage) {
        this.numeratorDetails = this.theme.filtered_coverage;
      } else {
        this.numeratorDetails = this.theme.coverage;
      }
    },
    offsetByPage(index) {
      return (this.pagination.page - 1) * this.pagination.limit + index;
    },
    forceClose() {
      if (this.showDialog) this.showDialog = false;
    },
    onClickOpen() {
      if (this.theme) {
        this.showDialog = true;
      }
    },
  },
  watch: {
    // parsedCoverage: async function () {
    //   this.updateDetails();
    // },
    // parsedFilteredCoverage: async function () {
    //   this.updateDetails();
    // },
    theme: async function () {
      this.updateDetails();
    },
  },
};
</script>

<style scoped>
.theme__popup-dialog {
  max-width: 32rem;
  width: calc(100% * 3);
}
</style>
